import { render, staticRenderFns } from "./CreateComparativeReportItemIcon.vue?vue&type=template&id=2cacabd2&scoped=true"
import script from "./CreateComparativeReportItemIcon.vue?vue&type=script&lang=js"
export * from "./CreateComparativeReportItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cacabd2",
  null
  
)

export default component.exports